import gsap from 'gsap';
import lodash from 'lodash';
export const Accordion = {
  init() {
    const btns = document.querySelectorAll('.js-acdn');
    if (btns.length) {
      btns.forEach((btn) => {
        btn.addEventListener('click', () => {
          this.toggle(btn);
        });
      });
    }
  },
  /**
   * @param {Element} btn
   * */
  toggle(btn) {
    btn.classList.toggle('is-open');
    const cont = document.getElementById(btn.getAttribute('aria-controls'));
    if (lodash.isElement(cont)) {
      if (btn.classList.contains('is-open')) {
        gsap.to(cont, {
          duration: 0.3,
          height: 'auto',
        });
      } else {
        gsap.to(cont, {
          duration: 0.3,
          height: '0px',
        });
      }
    }
  },
};
